import React, { useEffect } from "react";
import "./Product1.css";
import ecommerceDark from "../gif icons/shopping-dark.gif";
import menuDark from "../gif icons/menu.gif"; 
import posDark from "../gif icons/einvoice-dark.gif";
import inventoryDark from "../gif icons/inventory-dark.gif";

const products = [
  {
    id: "online-store",
    title: "Online Store",
    description: "Launch a custom e-commerce storefront tailored for high-volume sales. Our Online Store solution provides integrated payment gateways, fluid checkout flows, and direct synchronization with your central product catalog.",
    iconDark: ecommerceDark,
    slideDir: "slide-left",
  },
  {
    id: "digital-menu",
    title: "Digital Menu",
    description: "Engage customers with dynamic, QR-driven digital menus. Update items and pricing instantly in real time while providing rich visual media and touchless ordering for modern hospitality environments.",
    iconDark: menuDark,
    slideDir: "slide-right",
  },
  {
    id: "cloud-pos",
    title: "Cloud POS",
    description: "Unify your multi-location enterprise with a robust point-of-sale platform. Cloud POS handles rapid transaction processing, offline sync, and flexible payment methods without heavy hardware dependency.",
    iconDark: posDark,
    slideDir: "slide-left",
  },
  {
    id: "inventory",
    title: "Inventory",
    description: "Maintain complete visibility over your stock movements across all warehouses. Features include automated reordering triggers, low-stock notifications, batch tracking, and real-time reconciliation.",
    iconDark: inventoryDark,
    slideDir: "slide-right",
  },
];

const Product1 = () => {
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("in-view");
          }
        });
      },
      { threshold: 0.1 }
    );

    const elements = document.querySelectorAll(".product1 .animate-side");
    elements.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  return (
    <section className="product1">
      <div className="product1-container">
        <div className="animate-side slide-right">
          <h1>Functional Areas in DataHarbor</h1>
        </div>

        <div className="product1-content">
          {products.map((item) => (
            <div
              key={item.id}
              className={`product-paragraph-block animate-side ${item.slideDir}`}
            >
              <div className="product-header-inline">
                <div className="product-icon-wrapper">
                  <img
                    src={item.iconDark}
                    alt={`${item.title} icon`}
                    className="product-inline-icon"
                  />
                </div>
                <h2>{item.title}</h2>
              </div>
              <p className="product-text">{item.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Product1;